import { Badge } from "../ui/badge"
import { cn } from "../../lib/utils"

type Priority = "low" | "medium" | "high" | "urgent"

interface PriorityBadgeProps {
  priority: Priority | string
  className?: string
}

const priorityConfig: Record<Priority, { label: string; className: string }> = {
  low: { 
    label: "Низкий", 
    className: "bg-priority-low/10 text-priority-low border-priority-low/20" 
  },
  medium: { 
    label: "Средний", 
    className: "bg-priority-medium/10 text-priority-medium border-priority-medium/20" 
  },
  high: { 
    label: "Высокий", 
    className: "bg-priority-high/10 text-priority-high border-priority-high/20" 
  },
  urgent: { 
    label: "Срочный", 
    className: "bg-priority-urgent/10 text-priority-urgent border-priority-urgent/20" 
  },
}

export function PriorityBadge({ priority, className }: PriorityBadgeProps) {
  const config = priorityConfig[priority as Priority] || { label: priority, className: "bg-muted text-muted-foreground border-border" }
  return (
    <Badge 
      variant="outline" 
      className={cn("text-xs font-medium border", config.className, className)}
    >
      {config.label}
    </Badge>
  )
}

